import { newAxiosIns } from '@/libs/axios'

export function apiAddWareHouses({
  name, detail_address, zip_code, destination_id, pic_name, pic_phone, lat, long,
}) {
  const params = {
    name,
    detail_address,
    destination_id,
    zip_code,
    pic_name,
    pic_phone,
    lat,
    long,
    type: 1,
  }
  Object.keys(params).forEach(
    key => (params[key] === undefined || params[key] === null || params[key] === '') && delete params[key],
  )
  return newAxiosIns.post('komship/api/v1/warehouses/addresses', params)
}
export function apiListWareHousess() {
  return newAxiosIns.get('komship/api/v1/warehouses/addresses')
}
